import React, { useState, useEffect, useRef } from 'react';
import { jwtDecode } from "jwt-decode";
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import api from "./api";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Nav, Container } from 'react-bootstrap';
import LandingPage from './pages/LandingPage';
import TestOne from './pages/TestOne';
import Frameworks from './pages/Frameworks';
import Dashboard from './pages/Dashboard';
import Tests from './pages/Tests';
import ResearchNews from './pages/ResearchNews';
import MyAccount from './pages/MyAccount';
import SignupForm from './pages/SignupForm';
import AboutUs from './pages/AboutUs';
import Membership from './pages/Membership';
import Community from './pages/Community';
import ContactUs from './pages/ContactUs';
import ResultsPage from "./pages/ResultsPage";
import './pages/ResultsPage.css';
import './App.css';
import ExtraContent from './pages/ExtraContent';
import { Analytics } from "@vercel/analytics/react"
import './pages/Login.css';
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import HiveMindHome from "./hivemind/pages/HiveMindHome";
import Quiz from "./components/Quiz";
import './components/Quiz.css';
import ShareLanding from "./pages/ShareLanding";
import FrameworksApp from './Frameworks/UnifiedApp.jsx';

import TermsOfService from './Terms';
import PrivacyPolicy from './Privacy';

// Import logo image
import VyblyLogo from './pages/VyblyCompleteLogoWhite.png';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";
console.log(API_BASE_URL)

// Inline ResultsPage component (unchanged)
/* const ResultsPage = ({ result, onSignupSuccess }) => {
  const [boxHeight, setBoxHeight] = useState(null);
  const hiddenRef = useRef(null);
  const resultBoxRef = useRef(null);

  useEffect(() => {
    if (hiddenRef.current) {
      const measuredHeight = hiddenRef.current.getBoundingClientRect().height;
      setBoxHeight(measuredHeight + 20);
    }
  }, [result]);

  useEffect(() => {
    if (resultBoxRef.current && boxHeight) {
      const currentHeight = resultBoxRef.current.scrollHeight;
      if (currentHeight > boxHeight) {
        setBoxHeight(currentHeight + 10);
      }
    }
  }, [result, boxHeight]);

  return (
    <div className="results-container">
      <div className="hidden-text" ref={hiddenRef}>
        {result}
      </div>
      <div className="result-box" ref={resultBoxRef} style={{ height: boxHeight ? `${boxHeight}px` : 'auto' }}>
        <p className="result-text">{result}</p>
      </div>
      <div className="signup-wrapper">
        <h3>Ready to get started?</h3>
        <p className="privacy-note">
          Your email and phone number are used solely for account security and to preserve your anonymity.
        </p>
        <div className="signup-button-wrapper">
          <SignupForm onSignupSuccess={onSignupSuccess} />
        </div>
      </div>
    </div>
  );
}; */

const LoginPage = ({ setIsLoggedIn }) => {
  const [require2FA, setRequire2FA] = useState(false);
  const [otp, setOtp] = useState("");
  const [pendingUserId, setPendingUserId] = useState(null);
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const expired = params.get("expired");

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      localStorage.clear();
      const formData = new FormData();
      formData.append("username", credentials.email);
      formData.append("password", credentials.password);
      const response = await api.post(`${API_BASE_URL}/login/`, formData);
      if (response.data && response.data["2fa_required"]) {
        setRequire2FA(true);
        setPendingUserId(response.data.user_id);
        return;
      }
      const { token, user_id } = response.data;
      localStorage.setItem("token", token);
      localStorage.setItem("user_id", user_id);
      setIsLoggedIn(true);
      navigate("/frameworks");
    } catch (error) {
      setError("Invalid email or password");
    }
  };

  const handle2FAVerify = async (e) => {
    e.preventDefault();
    try {
      const resp = await api.post(`${API_BASE_URL}/api/2fa/verify/`, {
        user_id: pendingUserId,
        otp_code: otp,
      });
      localStorage.setItem("token", resp.data.token);
      localStorage.setItem("user_id", resp.data.user_id);
      setIsLoggedIn(true);
      navigate("/frameworks");
    } catch (e) {
      setError("Incorrect 2FA code. Try again.");
    }
  };

    // Send user to the landing page, then smooth-scroll to the embedded quiz
  const goToQuiz = () => {
    const doScroll = () => {
      const el = document.getElementById('quiz-section');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(doScroll, 0);
    } else {
      doScroll();
    }
  };

    // Handle special case: user came from reset-password with 2FA
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("2fa_reset") === "1" && params.get("user_id")) {
      setRequire2FA(true);
      setPendingUserId(params.get("user_id"));
    }
  }, [location]);


  return (
    <div className="login-bg">
      <div className="login-card">
        <div className="vybly-logo">
          <img src="/VyblyCompleteLogoBlack.png" alt="Vybly Logo" className="invert-logo" />
        </div>
        <h2 className="login-title">Login</h2>
        {expired && (
          <div className="login-expired">
            It's been a while since we last checked your credentials.<br />
            For your security, please log back in.
          </div>
        )}
        {error && <div className="login-error">{error}</div>}
        <form onSubmit={handleLogin} autoComplete="off">
          <input
          className="login-input"
          type="email"
          placeholder="Email"
          value={credentials.email}
          onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
          required
          disabled={require2FA}
        />
        <input
          className="login-input"
          type="password"
          placeholder="Password"
          value={credentials.password}
          onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
          required
          disabled={require2FA}
        />
        <div style={{ marginTop: 8, marginBottom: 12 }}>
          <a href="/forgot-password" style={{ color: "#007bff" }}>
            Forgot password?
          </a>
        </div>
          {!require2FA && (
            <button className="login-btn" type="submit">Login</button>
          )}
          {require2FA && (
            <div className="login-2fa-panel">
              <label className="login-label" htmlFor="otp">
                Enter 2FA Code
              </label>
              <input
                className="login-input"
                id="otp"
                type="text"
                value={otp}
                onChange={e => setOtp(e.target.value.replace(/\D/g, ""))}
                maxLength={6}
                placeholder="123456"
                autoFocus
              />
              <button className="login-btn" onClick={handle2FAVerify} type="button">
                Verify
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

const App = () => {

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
  const params = new URLSearchParams(location.search);
  // handle params as needed
}, [location]);

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const didFetchRef = useRef(false);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [shortAnswers, setShortAnswers] = useState({});     // {"1": "...", ... "7":"..."}
  const [navTransparent, setNavTransparent] = useState(false);
  const [navExpanded, setNavExpanded] = useState(false); 

  useEffect(() => {
    if (location.pathname !== "/") {
      setNavTransparent(false);
      return;
    }
    const handleScroll = () => {
      const hero = document.querySelector(".heroExact");
      if (!hero) return;
      const heroHeight = hero.offsetHeight;
      setNavTransparent(window.scrollY < heroHeight - 60);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location]);
  useEffect(() => {
    // Close the mobile menu when navigating
    setNavExpanded(false);
  }, [location]);

  const [userAnswers, setUserAnswers] = useState([]);
  const [result, setResult] = useState('');

    function checkTokenExpiry() {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const { exp } = jwtDecode(token);
        if (Date.now() >= exp * 1000) {
          localStorage.removeItem("token");
          localStorage.removeItem("user_id");
          window.location.href = "/login?expired=1";
        }
      } catch {}
    }
  }

  useEffect(() => {
    checkTokenExpiry();
  }, [location]);

  useEffect(() => {
    const interval = setInterval(checkTokenExpiry, 1 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!isLoggedIn) {
      didFetchRef.current = false;
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (didFetchRef.current) return;
    didFetchRef.current = true;
    const fetchQuestions = async () => {
      try {
        const response = await api.get(`${API_BASE_URL}/api/quiz_v2/questions`);
        setQuestions(response.data.questions || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching questions:", error);
        setLoading(false);
      }
    };
    fetchQuestions();
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, [location]);

  const resetQuiz = () => {
    setCurrentQuestionIndex(0);
    setUserAnswers([]);
    setResult('');
  };

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    resetQuiz();
    navigate("/", { replace: true });
  };

  const handleAccountDeletion = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    navigate("/", { replace: true });
  };

  const handleAnswerSelect = async (answerIndex) => {
    const updatedAnswers = [...userAnswers];
    updatedAnswers[currentQuestionIndex] = answerIndex;
    setUserAnswers(updatedAnswers);
    if (currentQuestionIndex === questions.length - 1) {
      await submitShortAnswers(updatedAnswers);
    } else {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    }
  };

  const submitShortAnswers = async () => {
    try {
      const payload = {
        answers: shortAnswers,                               // { "1": "...", "2": "...", ... }
        user_id: Number(localStorage.getItem("user_id")) || undefined
      };
      const response = await api.post(`${API_BASE_URL}/api/quiz_v2/submit`, payload);

      // Persist full result for the results page and to unlock /signup
      localStorage.setItem('vybly_quiz_results', JSON.stringify(response.data));

      // Optional: compact inline summary (kept, since App.js still shows it in places)
      const axis = response.data.scores || response.data.axes || {};
      const lines = Object.entries(axis)
        .sort(([a],[b]) => a.localeCompare(b))
        .map(([k,v]) => `${k}: ${v >= 0 ? "+" : ""}${Number(v).toFixed(2)}`)
        .join(" · ");
      setResult(lines);

      // Go to results (not signup)
      navigate("/results");
    } catch (error) {
      console.error("Error submitting short answers:", error);
    }
  };

  const handleSignupSuccess = async (token, user_id) => {
    try {
      localStorage.clear();
      localStorage.setItem("token", token);
      localStorage.setItem("user_id", user_id);
      // Set all framework help flags to "0" (show pulse ONCE per framework after signup)
      ["Mind Map", "Coach", "Insights", "Vetos", "Blurbs"].forEach(fw => {
        localStorage.setItem(
          `helpSeen_${fw.replace(/\s/g, "")}_${user_id}`,
          "0"
        );
      });
      setIsLoggedIn(true);
      navigate("/frameworks");
    } catch (error) {
      console.error("Error handling signup success:", error);
    }
  };

  // Render quiz question content with embellishments
  const renderQuestion = () => {
    if (loading) return <div>Loading...</div>;
    if (!questions[currentQuestionIndex]) return <div>No questions available.</div>;
    const q = questions[currentQuestionIndex]; // {id,text,type,char_limit,min_words}
    const id = q.id;
    const val = shortAnswers[id] || "";
    const charLimit = q.char_limit || 180;
    const minWords = q.min_words || 5;
    const wordCount = (val.match(/\b[^\s]+\b/g) || []).length;
    const over = val.length > charLimit;
    const under = wordCount < minWords;

    return (
      <div className="quiz-container">
        <h3 className="quiz-question">{q.text}</h3>
        <textarea
          className="form-control"
          value={val}
          maxLength={charLimit}
          onChange={(e) => {
            const v = e.target.value;
            setShortAnswers(prev => ({ ...prev, [id]: v }));
          }}
          rows={4}
          placeholder="Type your one sentence (≤180 chars)…"
        />
        <div style={{display:'flex', justifyContent:'space-between', marginTop:8}}>
          <small>{wordCount} words (min {minWords})</small>
          <small>{val.length}/{charLimit}</small>
        </div>
        <div style={{marginTop:12}}>
          <button
            className="btn btn-primary"
            disabled={over || under || !val.trim()}
            onClick={() => {
              if (currentQuestionIndex === questions.length - 1) {
                submitShortAnswers();
              } else {
                setCurrentQuestionIndex(currentQuestionIndex + 1);
              }
            }}
          >
            {currentQuestionIndex === questions.length - 1 ? "See Results" : "Next"}
          </button>
        </div>
      </div>
    );
  };

  return (
    <>
      {/* Navbar with Logo */}
      <Navbar
        expand="lg"
        variant="dark"
        expanded={navExpanded}                               // NEW: control collapse state
        onToggle={(next) => setNavExpanded(next)}            // NEW: toggle handler
        className={navTransparent && !navExpanded ? "transparent" : ""}
        style={{
          minHeight: "56px",
          backgroundColor: (navTransparent && !navExpanded) ? "transparent" : "#5FB3B1",
          transition: "background-color 0.3s ease"
        }}
      >
        <Container>
          {/* LEFT: brand + primary nav */}
          <Navbar.Brand onClick={() => navigate('/')}>
            <img
              src={VyblyLogo}
              alt="Vybly Logo"
              style={{ height: '30px', marginRight: '10px' }}
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="main-nav" />
          <Navbar.Collapse id="main-nav">
            {!isLoggedIn ? (
              <>
                {/* Left: public nav */}
                <Nav className="me-auto">
                  <Nav.Link onClick={() => navigate('/')}>Get Started</Nav.Link>
                  <Nav.Link onClick={() => navigate('/about-us')}>About</Nav.Link>
                  <Nav.Link onClick={() => navigate('/membership')}>Membership</Nav.Link>
                 {/* <Nav.Link onClick={() => navigate('/community')}>Community</Nav.Link>*/}
                  <Nav.Link onClick={() => navigate('/contact-us')}>Contact</Nav.Link>
                </Nav>

                {/* Right: auth actions */}
                <Nav className="ms-auto align-items-center">
                  <Nav.Link onClick={() => navigate('/login')}>Log in</Nav.Link>
                  <Nav.Link
                    onClick={() => {
                      const doScroll = () => {
                        const el = document.getElementById('quiz-section');
                        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      };
                      if (location.pathname !== '/') {
                        navigate('/');
                        setTimeout(doScroll, 0);
                      } else {
                        doScroll();
                      }
                    }}
                    style={{
                      backgroundColor: '#ffbf00',
                      color: '#111',
                      fontWeight: 800,
                      borderRadius: '10px',
                      padding: '8px 14px',
                      marginLeft: '8px'
                    }}
                  >
                    Start Free
                  </Nav.Link>
                </Nav>
              </>
            ) : (
              <>
                {/* Left: logged-in nav */}
                <Nav className="me-auto">
                  <Nav.Link onClick={() => navigate('/hivemind')}>Hive‑Mind</Nav.Link>
                  <Nav.Link onClick={() => navigate('/frameworks')}>Frameworks</Nav.Link>
                  <Nav.Link onClick={() => navigate('/tests')}>DeepDives</Nav.Link>
                  <Nav.Link onClick={() => navigate('/dashboard')}>Dashboard</Nav.Link>
                  {/*<Nav.Link onClick={() => navigate('/researchnews')}>Research News</Nav.Link>*/}
                  <Nav.Link onClick={() => navigate('/myaccount')}>My Account</Nav.Link>
                </Nav>

                {/* Right: logout */}
                <Nav className="ms-auto">
                  <Nav.Link onClick={handleLogout} className="text-danger">Logout</Nav.Link>
                </Nav>
              </>
            )}
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Root Route: LandingPage and Quiz Section */}
      <Routes>
      <Route 
        path="/" 
        element={
          <>
            <LandingPage key={location.key} />
            <div id="quiz-section" style={{ padding: 0 }}>
              <Quiz
                apiBaseUrl={API_BASE_URL}
                onComplete={() => navigate('/results')}
              />
            </div>
            <ExtraContent />
          </>
        }
      />

        {/* Other Routes Wrapped in a Container */}
        <Route 
              path="/*" 
              element={
              <div className={location.pathname.startsWith('/hivemind') ? 'container-fluid px-3' : 'container mt-4'}>
              <Routes>
                <Route path="/signup" element={localStorage.getItem('vybly_quiz_results') ? <SignupForm onSignupSuccess={handleSignupSuccess} /> : <Navigate to="/" replace />}/>
                <Route path="/login" element={isLoggedIn ? <Navigate to="/frameworks" /> : <LoginPage setIsLoggedIn={setIsLoggedIn} />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/membership" element={<Membership />} />
                {/*<Route path="/community" element={<Community />} />*/}
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/results" element={<ResultsPage result={result} onSignupSuccess={handleSignupSuccess} />} />
                <Route path="/share" element={<ShareLanding />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                {isLoggedIn && (
                  <>
                    <Route path="/hivemind" element={<HiveMindHome />} />
                    <Route path="/frameworks" element={<FrameworksApp />} />
                    <Route path="/tests" element={<Tests />} />
                    <Route path="/test1" element={<TestOne />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/researchnews" element={<ResearchNews />} />
                    <Route path="/myaccount" element={<MyAccount onAccountDeleted={handleAccountDeletion} />} />
                  </>
                )}
              </Routes>
            </div>
          }
        />
      </Routes>
      <Analytics />
    </>
  );
};

export default App;